import { createThemeAssets, imageUrl } from '../createThemeAssets'

const themeImages = require.context('./images', true, /\.(png|jpe?g|webp|avif|gif|svg)$/)
const assets = createThemeAssets((path) => themeImages(`./${path}`))

export default {
    name: 'porcelain',
    label: 'Blue White',
    assets,
    cssVars: {
        '--theme-root-bg': '#edf6ff',
        '--theme-page-bg': [
            imageUrl(assets.home.pageBg),
            'radial-gradient(circle at 50% 0, rgba(255, 255, 255, .86) 0, rgba(255, 255, 255, 0) 44%)',
            'linear-gradient(180deg, rgba(244, 249, 255, .92) 0%, rgba(210, 229, 250, .82) 100%)'
        ].join(','),
        '--theme-page-bg-size': 'cover, 100% 7.2rem, 100% 100%',
        '--theme-page-bg-position': 'center top, center top, center top',
        '--theme-header-bg': 'linear-gradient(180deg, rgba(248, 252, 255, .98) 0%, rgba(214, 231, 250, .94) 100%)',
        '--theme-header-control-bg': '#eef7ff',
        '--theme-header-control-border': '#7ca7d9',
        '--theme-header-control-border-gradient': 'linear-gradient(180deg, rgba(255, 255, 255, .75), rgba(91, 133, 185, .95))',
        '--theme-header-accent-bg': 'linear-gradient(180deg, #f7fbff 0%, #a9c9ee 100%)',
        '--theme-surface-bg': 'rgba(236, 245, 255, .72)',
        '--theme-surface-border': '#83addd',
        '--theme-soft-text': '#426995',
        '--theme-bright-text': '#153b70',
        '--theme-input-bg': '#f6fbff',
        '--theme-input-border': '#8bb7e5',
        '--theme-input-focus-bg': '#e8f4ff',
        '--theme-input-focus-border': '#2f6fb8',
        '--theme-input-focus-border-rgb': '47, 111, 184',
        '--theme-input-placeholder': 'rgba(66, 105, 149, .68)',
        '--theme-list-bg': 'rgba(220, 235, 252, .54)',
        '--theme-list-header-bg': 'rgba(201, 222, 246, .86)',
        '--theme-list-row-border': 'rgba(47, 111, 184, .22)',
        '--theme-progress-track': 'linear-gradient(180deg, rgba(92, 132, 178, .42) 0%, rgba(255, 255, 255, .34) 100%)',
        '--theme-progress-fill': 'linear-gradient(90deg, #ff8a00 0%, #ffd15c 38%, #2f6fb8 100%)',
        '--theme-progress-shadow': '0 .04rem .12rem rgba(47, 111, 184, .32)',
        '--theme-active-bg': 'linear-gradient(180deg, #fdfefe 0%, #bdd8f5 100%)',
        '--theme-active-text': '#174579',
        '--theme-gold-bg': 'linear-gradient(180deg, #f9fbff 0%, #9bbce6 100%)',
        '--theme-gold-text': '#174579',
        '--theme-banner-bg': imageUrl(assets.home.bannerBg),
        '--theme-home-frame-corner-top-left': imageUrl(assets.home.frameCorners.topLeft),
        '--theme-home-frame-corner-top-right': imageUrl(assets.home.frameCorners.topRight),
        '--theme-home-frame-corner-bottom-left': imageUrl(assets.home.frameCorners.bottomLeft),
        '--theme-home-frame-corner-bottom-right': imageUrl(assets.home.frameCorners.bottomRight),
        '--theme-home-event-card-corner-top-left': imageUrl(assets.home.eventCardCorners.topLeft),
        '--theme-home-event-card-corner-top-right': imageUrl(assets.home.eventCardCorners.topRight),
        '--theme-home-event-card-corner-bottom-left': imageUrl(assets.home.eventCardCorners.bottomLeft),
        '--theme-home-event-card-corner-bottom-right': imageUrl(assets.home.eventCardCorners.bottomRight),
        '--theme-home-game-section-header-bg': imageUrl(assets.home.gameSectionHeaderBg),
        '--theme-home-jackpot-bg': imageUrl(assets.home.jackpotBg),
        '--theme-notification-bg-top1': imageUrl(assets.notification.bgTop1),
        '--theme-common-frame-corner-top-left': imageUrl(assets.common.frameCorners.topLeft),
        '--theme-common-frame-corner-top-right': imageUrl(assets.common.frameCorners.topRight),
        '--theme-common-frame-corner-bottom-left': imageUrl(assets.common.frameCorners.bottomLeft),
        '--theme-common-frame-corner-bottom-right': imageUrl(assets.common.frameCorners.bottomRight),
        '--theme-login-popup-image-bg': imageUrl(assets.login.popupBg),
        '--theme-home-classify-fixed-bg': 'linear-gradient(180deg, rgba(255, 255, 255, .9) 0%, rgba(215, 232, 250, .94) 100%)',
        '--theme-home-classify-item-bg': 'radial-gradient(circle at 12% 0, rgba(255, 255, 255, .92) 0, rgba(255, 255, 255, 0) 30%), linear-gradient(180deg, rgba(248, 252, 255, .98) 0%, rgba(183, 211, 242, .98) 100%)',
        '--theme-home-classify-icon-bg': '#d7e8fa',
        '--theme-home-classify-nav-bg': 'linear-gradient(180deg, rgba(255, 255, 255, .94) 0%, rgba(188, 215, 244, .98) 100%)',
        '--theme-home-classify-nav-border': 'rgba(47, 111, 184, .28)',
        '--theme-home-classify-nav-shadow': 'inset 0 1px 0 rgba(255, 255, 255, .8), 0 .04rem .1rem rgba(47, 111, 184, .16)',
        '--theme-home-banner-panel-bg': 'linear-gradient(135deg, rgba(255, 255, 255, .36), rgba(235, 244, 255, .58), rgba(154, 190, 230, .3))',
        '--theme-home-section-top-bg': 'linear-gradient(180deg, rgba(230, 242, 255, .8) 0%, rgba(230, 242, 255, 0) 100%)',
        '--theme-home-notice-line-bg': 'linear-gradient(180deg, #f7fbff 0%, #6f9bd0 100%)',
        '--theme-home-notice-item-bg': 'linear-gradient(-90deg, rgba(244, 250, 255, 0) 0%, rgba(217, 233, 250, .82) 100%)',
        '--theme-home-notice-icon-filter': 'brightness(0) saturate(100%) invert(34%) sepia(50%) saturate(875%) hue-rotate(179deg) brightness(91%) contrast(90%)',
        '--theme-game-placeholder-surface': 'linear-gradient(180deg, rgba(226, 240, 255, .96) 0%, rgba(171, 203, 237, .98) 100%)',
        '--theme-game-placeholder-skeleton': 'linear-gradient(110deg, rgba(255, 255, 255, 0) 30%, rgba(255, 255, 255, .6) 50%, rgba(255, 255, 255, 0) 70%), linear-gradient(180deg, rgba(210, 229, 250, .9) 0%, rgba(151, 185, 222, .94) 100%)',
        '--theme-game-placeholder-fallback': 'radial-gradient(circle at 50% 18%, rgba(255, 255, 255, .58) 0%, rgba(255, 255, 255, 0) 38%), linear-gradient(180deg, rgba(220, 235, 252, .96) 0%, rgba(159, 194, 232, .98) 100%)',
        '--theme-game-placeholder-border': 'rgba(47, 111, 184, .24)',
        '--theme-game-title-bg': 'linear-gradient(180deg, rgba(246, 251, 255, .94) 0%, rgba(196, 219, 246, .98) 100%)',
        '--theme-game-title-text': '#174579',
        '--theme-footer-border-top': imageUrl(assets.footer.borderTop),
        '--theme-footer-border-body': imageUrl(assets.footer.borderBody),
        '--theme-footer-title-text': '#174579',
        '--theme-footer-body-text': '#426995',
        '--theme-footer-muted-text': 'rgba(66, 105, 149, .86)',
        '--theme-footer-copyright-text': '#153b70',
        '--theme-footer-menu-title-bg': 'linear-gradient(90deg, rgba(215, 232, 250, .92) 0%, rgba(255, 255, 255, .08) 100%)',
        '--theme-footer-menu-title-line': imageUrl(assets.sidebar.menuItemBorder),
        '--theme-footer-menu-list-bg': 'linear-gradient(90deg, rgba(234, 244, 255, .72) 0%, rgba(255, 255, 255, .2) 100%)',
        '--theme-footer-menu-link-text': '#174579',
        '--theme-home-banner-html-text': '#315f99',
        '--theme-share-bg-top': imageUrl(assets.share.bgTop),
        '--theme-share-bg': imageUrl(assets.share.shareBg),
        '--theme-share-proxy-bg': imageUrl(assets.share.proxy),
        '--theme-person-vip-bg': imageUrl(assets.person.bgVip),
        '--theme-person-vip-pc-bg': imageUrl(assets.person.bgVipPc),
        '--theme-event-top-shell-bg': imageUrl(assets.event.topShellBg),
        '--theme-event-top-bg': imageUrl(assets.event.topBg),
        '--theme-event-top-right': imageUrl(assets.event.topRight),
        '--theme-event-detail-text': '#426995',
        '--theme-event-card-bg': 'rgba(236, 245, 255, .78)',
        '--theme-event-card-shadow': 'var(--theme-popup-panel-shadow)',
        '--theme-signin-vip-icon': imageUrl(assets.signIn.vipIcon),
        '--theme-signin-vip-icon-active': imageUrl(assets.signIn.vipIconActive),
        '--theme-signin-lock-icon': imageUrl(assets.signIn.lock),
        '--theme-signin-accent-text': '#1b66aa',
        '--theme-signin-accent-border': '#7ca7d9',
        '--theme-signin-progress-line': '#9bbce6',
        '--theme-signin-disabled-btn-bg': 'linear-gradient(180deg, rgba(204, 218, 234, .96) 0%, rgba(142, 165, 192, .98) 100%)',
        '--theme-signin-disabled-btn-text': '#426995',
        '--theme-signin-day-bg': 'linear-gradient(180deg, #f7fbff 0%, #a9c9ee 100%)',
        '--theme-signin-day-border': '#7ca7d9',
        '--theme-signin-unlocked-bg': 'linear-gradient(180deg, #ffffff 0%, #bdd8f5 99.29%)',
        '--theme-signin-secondary-amount-text': '#2f6fb8',
        '--theme-signin-nav-btn-bg': 'rgba(47, 111, 184, .14)',
        '--theme-signin-active-icon-shadow': '0px 2px 4px 0px rgba(47, 111, 184, .22)',
        '--theme-frame-line-vertical': 'linear-gradient(to bottom, transparent 0%, #9bbce6 10%, #2f6fb8 50%, #9bbce6 85%, transparent 100%)',
        '--theme-frame-line-horizontal': 'linear-gradient(to right, transparent 0%, #9bbce6 15%, #2f6fb8 50%, #9bbce6 85%, transparent 100%)',
        '--theme-tabbar-shell-bg': '#f6fbff',
        '--theme-tabbar-text': 'rgba(37, 80, 130, .72)',
        '--theme-tabbar-active-text': '#174579',
        '--theme-tabbar-float-bg': 'linear-gradient(180deg, rgba(255, 255, 255, .98) 0%, rgba(216, 233, 251, .98) 100%)',
        '--theme-tabbar-divider': 'rgba(47, 111, 184, .2)',
        '--theme-tabbar-active-bg': [
            imageUrl(assets.tabbar.activeBorders[0]),
            imageUrl(assets.tabbar.activeBorders[1]),
            imageUrl(assets.tabbar.activeBorders[2]),
            imageUrl(assets.tabbar.activeBorders[3]),
            'linear-gradient(180deg, #ffffff 0%, #d7e8fa 100%)'
        ].join(','),
        '--theme-tabbar-active-bg-size': '.72rem .45rem, .72rem .45rem, .72rem .45rem, .72rem .45rem, 100% 100%',
        '--theme-tabbar-active-bg-position': 'top left, top right, bottom left, bottom right, bottom left',
        '--theme-popup-bg': 'linear-gradient(180deg, #f6fbff 0%, #c8def6 100%)',
        '--theme-popup-overlay-bg': 'rgba(22, 49, 86, .56)',
        '--theme-popup-close-bg': '#edf6ff',
        '--theme-popup-close-border': '#7ca7d9',
        '--theme-popup-panel-bg': 'rgba(236, 245, 255, .76)',
        '--theme-popup-panel-fill': '#e8f4ff',
        '--theme-popup-panel-border': 'linear-gradient(180deg, rgba(255, 255, 255, .7), rgba(91, 133, 185, .18))',
        '--theme-popup-panel-shadow': 'inset .16rem .16rem .58rem 0 rgba(255, 255, 255, .35), inset -.16rem -.16rem .58rem 0 rgba(91, 133, 185, .18)',
        '--theme-panel-strong-bg': 'linear-gradient(180deg, #ffffff 0%, #bdd8f5 100%)',
        '--theme-card-strong-bg': 'linear-gradient(180deg, #f6fbff 0%, #c7ddf4 100%)',
        '--theme-card-strong-border': '#7ca7d9',
        '--theme-popup-tabs-bg': 'rgba(213, 231, 250, .82)',
        '--theme-popup-mask-bg': 'rgba(22, 49, 86, .3)',
        '--theme-popup-box-bg': 'rgba(238, 247, 255, .94)',
        '--theme-popup-box-border': '#8bb7e5',
        '--theme-popup-box-shadow': 'inset 0 0 .12rem 0 rgba(47, 111, 184, .28), 0 .06rem .16rem rgba(47, 111, 184, .12)',
        '--theme-popup-amount-text': '#1b66aa',
        '--theme-sidebar-bg': [
            'linear-gradient(180deg, rgba(247, 251, 255, .96) 0%, rgba(206, 226, 248, .98) 100%)',
            imageUrl(assets.home.pageBg)
        ].join(','),
        '--theme-sidebar-bg-size': '100% 100%, cover',
        '--theme-sidebar-border': 'rgba(47, 111, 184, .24)',
        '--theme-sidebar-menu-item-border': imageUrl(assets.sidebar.menuItemBorder),
        '--theme-sidebar-hot-bg': imageUrl(assets.sidebar.hotBg),
        '--theme-sidebar-item-text': '#426995',
        '--theme-sidebar-item-active-bg': 'linear-gradient(-90deg, rgba(255, 255, 255, 0) 0%, rgba(166, 202, 240, .92) 100%)',
        '--theme-sidebar-item-active-line': 'linear-gradient(180deg, #ffffff 0%, #6f9bd0 100%)',
        '--theme-sidebar-control-bg': '#f6fbff',
        '--theme-sidebar-control-border': '#8bb7e5',
        '--theme-sidebar-service-bg': 'linear-gradient(180deg, #ffffff 0%, #bdd8f5 100%)',
        '--theme-sidebar-drawer-mask-bg': 'rgba(47, 111, 184, .28)'
    }
}
